{
    "Accessibility Menu": "Menu Truy cập",
    "Reset settings": "Đặt lại cài đặt",
    "Close": "Đóng",
    "Content Adjustments": "Điều chỉnh Nội dung",
    "Adjust Font Size": "Điều chỉnh Kích thước Font chữ",
    "Highlight Title": "Đánh dấu Tiêu đề",
    "Highlight Links": "Đánh dấu Liên kết",
    "Readable Font": "Font chữ Dễ đọc",
    "Color Adjustments": "Điều chỉnh Màu sắc",
    "Dark Contrast": "Tương phản Tối",
    "Light Contrast": "Tương phản Sáng",
    "High Contrast": "Tương phản Cao",
    "High Saturation": "Bão hòa Cao",
    "Low Saturation": "Bão hòa Thấp",
    "Monochrome": "Đơn sắc",
    "Protanopia": "Mù màu đỏ",
    "Deuteranopia": "Mù màu xanh lá",
    "Tritanopia": "Mù màu xanh lam",
    "Visual & Navigation Aids": "Hỗ trợ Thị giác và Điều hướng",
    "Additional Tools": "Công cụ Bổ sung",
    "Reading Guide": "Hướng dẫn Đọc",
    "Stop Animations": "Dừng Hoạt hình",
    "Big Cursor": "Con trỏ Lớn",
    "Screen Reader": "Trình đọc Màn hình",
    "Hide Images": "Ẩn Hình ảnh",
    "Image Tooltips": "Chú thích Hình ảnh",
    "Page Structure": "Cấu trúc Trang",
    "Super Focus": "Siêu Tập trung",
    "Magnifier": "Kính Phóng đại",
    "Increase Font Size": "Tăng Kích thước Font chữ",
    "Decrease Font Size": "Giảm Kích thước Font chữ",
    "Letter Spacing": "Khoảng cách Chữ",
    "Line Height": "Độ Cao dòng",
    "Font Weight": "Độ Đậm của Font chữ",
    "Dyslexia Font": "Font chữ Cho người có Khuyết tật đọc hiểu",
    "Language": "Ngôn ngữ",
    "Open Accessibility Menu": "Mở Menu Truy cập",
    "Accessibility Profiles": "Hồ sơ Trợ năng",
    "Seizure Safe Profile": "Hồ sơ An toàn Động kinh",
    "Stops animations and reduces color saturation.": "Dừng hoạt hình và giảm độ bão hòa màu sắc.",
    "Blind Profile": "Hồ sơ Người mù",
    "Activates the screen reader for auditory navigation.": "Kích hoạt trình đọc màn hình để điều hướng bằng âm thanh.",
    "Visually Impaired Profile": "Hồ sơ Khiếm thị",
    "Enhances contrast and readability for low vision.": "Tăng cường độ tương phản và khả năng đọc cho người thị lực kém.",
    "ADHD Friendly Profile": "Hồ sơ Thân thiện ADHD",
    "Reduces distractions for better focus.": "Giảm phiền nhiễu để tập trung tốt hơn.",
    "Cognitive & Learning Profile": "Hồ sơ Nhận thức và Học tập",
    "Helpful tools for reading and comprehension.": "Công cụ hữu ích cho việc đọc và hiểu.",
    "Motor Impaired Profile": "Hồ sơ Khuyết tật Vận động",
    "Optimizes the site for keyboard-only navigation.": "Tối ưu hóa trang web cho điều hướng chỉ bằng bàn phím.",
    "Headings": "Tiêu đề",
    "Landmarks": "Điểm mốc",
    "Links": "Liên kết",
    "Focus element": "Tập trung vào phần tử",
    "Visit link": "Truy cập liên kết"
}
